export const CME_REPORT_KEYS: Array<"opened" | "read_materials" | "answered" | "awarded"> = [
  "opened",
  "read_materials",
  "answered",
  "awarded",
];

export const CME_SEARCH_ONLY_KEYS = ["name"];
